<div class="modal-dialog feature-flag-dialog-container">
	<div class="modal-content" cdkTrapFocus>
		<div class="goreact-modal-header">
			<h4 class="modal-title" translate="feature-flags"></h4>
			<button type="button" class="close-btn" (click)="close()" aria-label="Close">
				<i class="ficon-app-x"></i>
			</button>
		</div>
		<div class="goreact-modal-body">
			<div *ngFor="let flag of featureFlags | keyvalue">
				<mat-slide-toggle *ngIf="(flag.value === true || flag.value === false); else notBool" color="primary" [(ngModel)]="flag.value" (change)="toggleFlag(flag)">
					{{flag.key}}
				</mat-slide-toggle>
				<ng-template #notBool>
					<div class="complexFlag">
						{{flag.key}}
						<div *ngFor="let complexFlag of flag.value | keyvalue">
							{{complexFlag.key}}
							<div *ngFor="let complexValues of complexFlag.value | keyvalue" class="indent">
								<mat-slide-toggle color="primary" [(ngModel)]="complexValues.value" (change)="toggleComplexFlag(flag, complexFlag, complexValues)">
									{{complexValues.key}}
								</mat-slide-toggle>
							</div>
						</div>
					</div>
				</ng-template>
			</div>
		</div>
		<div class="goreact-modal-footer">
			<button class="secondary-btn" (click)="reset()" translate="reset-and-close"></button>
			<button class="primary-btn" (click)="close()" translate="common_close" data-cy="common_close"></button>
		</div>
	</div>
</div>
